export default __webpack_public_path__ + "static/media/f-organico.f89dad5d.svg";